import React from 'react'
import o from '../../components/Overlay.module.css'
import own from './SdPanel.module.css'

// The Stock & Dispatch action panel (V4 sd-module "panel": a 520px right-hand
// sheet over the record it acts on, title in the display face, the action
// first and Cancel after it). Built from the overlay kit; the caller keeps its
// own useLayer, so dirty guards, focus and Escape behave as before.

export function CloseIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" aria-hidden="true">
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  )
}

export function CloseButton({ onClick, disabled, title }: { onClick: () => void; disabled?: boolean; title?: string }) {
  return (
    <button type="button" className={o.close} aria-label="Close" title={title} disabled={disabled} onClick={onClick}>
      <CloseIcon />
    </button>
  )
}

export function SdPanel({
  title,
  sub,
  onCancel,
  children,
  foot,
  confirm,
  panelEl,
  busy,
  cancelLabel = 'Cancel',
  wide,
  bodyClass,
}: {
  title: string
  sub?: React.ReactNode
  onCancel: () => void
  children: React.ReactNode
  foot?: React.ReactNode
  confirm?: React.ReactNode
  panelEl?: React.RefObject<HTMLDivElement>
  busy?: boolean
  cancelLabel?: string
  wide?: boolean
  bodyClass?: string
}) {
  return (
    <div
      className={o.drawerScrim}
      onClick={(e) => {
        e.stopPropagation()
        if (e.target === e.currentTarget && !busy) onCancel()
      }}
    >
      <div ref={panelEl} tabIndex={-1} className={`${o.drawer} ${wide ? own.panelWide : own.panel}`} role="dialog" aria-label={title}>
        <div className={o.drawerHead}>
          <div className={o.headText}>
            <h2 className={o.drawerTitle}>{title}</h2>
            {sub && <p className={o.drawerSub}>{sub}</p>}
          </div>
          <CloseButton onClick={onCancel} disabled={busy} />
        </div>
        <div className={`${o.drawerBody} ${own.body} ${bodyClass || ''}`}>{children}</div>
        <div className={`${o.drawerFoot} ${own.foot}`}>
          {foot}
          <button type="button" className={o.ghost} disabled={busy} onClick={onCancel}>
            {cancelLabel}
          </button>
        </div>
      </div>
      {confirm}
    </div>
  )
}
